// mutations
const RESTAURANT_ENLISTMENT_ALL = (state, enlistment) => {
  if (enlistment.code === 1) {
    state.enlistment = enlistment.data
    state.status = 'success'
  } else {
    alert(enlistment.message)
    state.status = 'error'
  }
}

const RESTAURANT_ENLISTMENT_FORM = (state, enlistment) => {
  if (enlistment.code === 1) {
    state.enlistment = enlistment.data
    state.status = 'success'
  } else {
    alert(enlistment.message)
    state.status = 'error'
  }
}

const RESTAURANT_ENLISTMENT_SHOW = (state, enlistment) => {
  if (enlistment.code === 1) {
    state.enlistment = enlistment.data
    state.status = 'success'
  } else {
    alert(enlistment.message)
    state.status = 'error'
  }
}

const RESTAURANT_ENLISTMENT_CREATE = (state, enlistment) => {
  if (enlistment.code === 1) {
    state.enlistment = enlistment.data
    state.status = 'success'
  } else {
    alert(enlistment.message)
    state.status = 'error'
  }
}

const RESTAURANT_ENLISTMENT_UPDATE = (state, enlistment) => {
  if (enlistment.code === 1) {
    state.enlistment = enlistment.data
    state.status = 'success'
  } else {
    alert(enlistment.message)
    state.status = 'error'
  }
}

const RESTAURANT_ENLISTMENT_DELETE = (state, enlistment) => {
  if (enlistment.code === 1) {
    state.enlistment = enlistment.data
    state.status = 'success'
  } else {
    alert(enlistment.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_ENLISTMENT_ALL,
  RESTAURANT_ENLISTMENT_FORM,
  RESTAURANT_ENLISTMENT_SHOW,
  RESTAURANT_ENLISTMENT_CREATE,
  RESTAURANT_ENLISTMENT_UPDATE,
  RESTAURANT_ENLISTMENT_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/enlistment/mutations.js